import React, { useState, useEffect } from "react";
import "./VendorCategorys.css";
import Filter from "../Vendor/FilterBar";

const BASE_URL = process.env.REACT_APP_BASE_URL

function VendorCategorys() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/v1/VendorManagement/show-Categories`
        );
        const data = await response.json();

        if (data?.data?.ShowAllCategorie) {
          setCategories(data.data.ShowAllCategorie);
        } else {
          throw new Error("Unexpected API response structure");
        }
      } catch (err) {
        console.error("Error fetching categories:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const handleCardClick = (categoryName) => {
    window.location.href = `/vendor-list?category=${encodeURIComponent(
      categoryName
    )}`;
  };

  // Function to safely parse CategorieImage field and get image path
  const getImagePath = (categorieImage) => {
    try {
      console.log("Raw CategorieImage:", categorieImage); // Log initial input
  
      // Parse the stringified JSON
      const parsedImage = JSON.parse(categorieImage);
      console.log("Parsed Image:", parsedImage); // Log after parsing
  
      // Ensure the 'path' exists
      const imagePath = parsedImage[0]?.path;
      console.log("Extracted Path:", imagePath); // Log the extracted path
  
      // Return the path relative to the server's public directory
      if (imagePath) {
        const cleanedPath = `${BASE_URL}/${imagePath
          .replace("/home/ubuntu/new/CEP_BackEnd/", "")
          .replace("/home/CEP_BackEnd/", "")
          .replace(/^\/+/, "")}`; // Ensure no leading slash issues
        
        
        console.log("Final Image Path:", cleanedPath); // Log final transformed path
        return cleanedPath;
      }
    } catch (e) {
      console.error("Error parsing CategorieImage:", e);
      return null; // Return null if parsing fails
    }
  
    console.log("No valid path found.");
    return null; // Return null if no valid path is found
  };
  
  return (
    <div id="VendorCategorys">
      <div className="row align-items-center mt-5">
        <div className="centered-container">
          <h2 className="section-heading">Wedding Categories</h2>
          <p className="section-para">Perfect Vendors</p>
        </div>
      </div>

      {loading && <div>Loading categories...</div>}
      {error && <div>Error: {error}</div>}

      <div className="row mt-5 card-container">
        {categories
          .filter((category) => category.status === true)
          .map((category) => {
            // Safely get the image path
            const imagePath = getImagePath(category.CategorieImage);

            return (
              <div className="col-md-6" key={category.id}>
                <div
                  className="card"
                  onClick={() => handleCardClick(category.CategorieName)}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={
                      imagePath
                        ? imagePath // Use parsed path
                        : "default-image.jpg" // Fallback to a default image
                    }
                    className="card-img-top"
                    alt={category.CategorieName}
                  />
                  <div className="card-body">
                    <h5 className="card-title">{category.CategorieName}</h5>
                    <p className="card-text">
                      Explore the best vendors for {category.CategorieName}.
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default VendorCategorys;
